import { gql } from '@apollo/client/core';
import { Trans } from '@lingui/macro';
import React from 'react';
import { DynamicComponent } from '..';

/**
 *
 * @param {object} props
 * @param {object} props.style
 * @param {Array.<'fullName' | 'title' | 'email' | 'website' | 'telephone' | 'companyName'>} props.includeAttributes - specify which attributes and their order
 * @returns
 */
export default function DistributionContacts({
  producer,
  style,
  includeAttributes = ['fullName', 'companyName', 'email', 'website'],
  ...rest
}) {
  if (!hasContent(producer)) return null;
  const distributionContacts = producer.distributionContacts?.[0];
  return (
    <DynamicComponent.Wrapper style={style} {...rest}>
      <DynamicComponent.Label {...rest}>
        <Trans>Distribution</Trans>
      </DynamicComponent.Label>
      {producer?.isSeekingDistribution ? (
        <DynamicComponent.Value {...rest}>
          <Trans>Seeking Distribution</Trans>
        </DynamicComponent.Value>
      ) : (
        <React.Fragment>
          {/* We need a better way of handling self-distribution */}
          {includeAttributes.map((parameter) => (
            <DynamicComponent.Value
              key={Math.floor(Math.random() * 1000)}
              {...rest}
            >
              {distributionContacts[parameter]}
            </DynamicComponent.Value>
          ))}
        </React.Fragment>
      )}
    </DynamicComponent.Wrapper>
  );
}

DistributionContacts.hasContent = hasContent;

function hasContent(producer) {
  if (!producer) return false;
  if (producer.isSeekingDistribution) return true;
  if (producer.distributionContacts?.length) return true;
  return false;
}

DistributionContacts.fragment = gql`
  fragment DistributionContacts on RegisteredBrand {
    isSeekingDistribution
    distributionContacts {
      companyId
      fullName
      companyName
      telephone
      website(format: TEXT)
      email(format: TEXT)
    }
  }
`;
